<template>
  <div class="login-wrap" ref="editorDOM" style="overflow:hidden">
    <div class="temp-box">
      <img class="img" src="../images/bg.jpg" alt="">
      <div class="login-form">
        <div class="bg-box"></div>
        <div class="real-box">
          <h2>用户登录</h2>
          <div class="tab">
            <div class="tabTitle" :class="tab==1?'now':''" @click="tabChange(1)">密码登录</div>
            <div class="tabTitle" :class="tab==2?'now':''" @click="tabChange(2)">验证码登录</div>
          </div>
          <div class="usually-box user-wrap">
            <label v-if="tab==1">用户名</label>
            <label v-if="tab==2">手机号</label>
            <input v-model="username" type="text" placeholder="请输入手机号码" autoComplete="off">
          </div>
          <div v-if="tab==1" class="usually-box password-wrap">
            <label>密码</label>
            <input v-model="password" type="password" placeholder="请输入密码" autoComplete="new-password">
          </div>
          <div v-show="tab==1" class="usually-box yz-wrap">
            <label>验证码</label>
            <input v-model="picCode" type="text" placeholder="请输入验证码" >
            <canvas @click="drawCanvas" id="yzm"></canvas>
          </div>
          <div v-if="tab==2" class="usually-box yzt-wrap">
            <label>验证码</label>
            <input v-model="yzm" type="text" placeholder="请输入短信验证码" autoComplete="off">
            <span class="get-yzm" @click="getYzm">{{yzmTxt}}</span>
          </div>
          <div v-if="tab==1" class="login-btn" @click="sendPost">
            <img src="../images/login-img1.png" alt=""><span>登录</span> 
          </div>
          <div v-if="tab==2" class="login-btn" @click="sendSmsPost">
            <img src="../images/login-img1.png" alt=""><span>登录</span> 
          </div>
          <div class="txt">
            <a @click="goRegister">还没有账号？立即注册</a><a @click="goResetPassword">忘记密码</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { JSEncrypt } from 'jsencrypt';
import { getLLPosition } from '@/utils/index'
export default {
  name: "login-001-commmon",
  data() {
    return Object.assign(
      {
        username: '',
        password: '',
        picCode: '',
        yzm: "",
        publicKey: "",
        selfPicYzm: "",
        tab: 1,       // 登录方式，1.密码登录、2.验证码登录
        yzmTxt: "获取验证码",       // 获取验证码内容
        yzmNum: 120,               // 验证码倒计时
        yzmTimer: null,            // 验证码计时器
      }
    );
  },
  created() {
    this.checkLoginStatus();
    this.getPublicKey();
  },
  mounted() {
    this.drawCanvas();
  },
  methods: {
    // 检查是否登录
    checkLoginStatus(){
      let ut = localStorage.getItem('ut');
      console.log(ut, '=================ut')
      console.log(typeof ut, '=================ut')
      const LoginStatus = ut == undefined || ut == null || ut == 'undefined' || ut == 'null' || ut == '';
      // localStorage中没有ut，判断是否登录
      if(!LoginStatus){
        console.log('当ut存在时我才走这里..............')
        this.$router.push("/personalCenter/personalInfomation");
      }
    },
    // 登录方式切换
    tabChange(value){
      console.log("tabChange:",value)
      this.tab = value;
      // this.drawCanvas();
      let timer = setTimeout(() => {
        this.drawCanvas();
        clearTimeout(timer);
      }, 10);
    },
    // 获取公匙
    getPublicKey() {
      this.$API.rsaPublic().then(res => {
        if(res.code == 0) {
          this.publicKey = res.data;
        }else {
          this.$message.error(res.msg);
        }
      });
    },
    // 加密
    setEncrypt(msg) {
      let jsencrypt = new JSEncrypt({});
      jsencrypt.setPublicKey(this.publicKey);
      return jsencrypt.encrypt(msg);
    },
    setDncrypt() {
      let jsencrypt = new JSEncrypt({});
      jsencrypt.setPrivateKey('Mss1F+RkSxMoW/3q/hWq8oMbwb8IWt4fs7BjCK6PUAFSPofnZC2kS9anglftfPG+FOVWtuTXL19Q1zjmJvBqQVTrOCBD8EnLqqnAsF4h8ERNslDoE2a7rm2/MJNKczi7lyGW7uxnvO5MkPBnFQWLb73Y4RHog9t0kuH6RCX8/qQ=');
      return jsencrypt.decrypt();
    },
    // 获取验证码
    getYzm() {
      if(!this.username) {
        this.$message.warning("请输入手机号");
        return
      }
      if(this.yzmTxt != '获取验证码') {
        return
      }
      this.yzmTimer = setInterval(() => {
        this.yzmTxt = this.yzmNum + 's';
        this.yzmNum--;
        if(this.yzmNum <= 0) {
          this.yzmNum = 120;
          this.yzmTxt = '获取验证码';
          clearInterval(this.yzmTimer);
        }
      }, 1000);
      let phone = this.setEncrypt(this.username);
      let language = this.setEncrypt('zh');
      let purpose = this.setEncrypt('L');
      let sys = this.setEncrypt(this.HOSPITAL.sys); //合肥sys传h02site,苏州成都传ohealth
      let templateNo = this.setEncrypt(this.HOSPITAL.templateNo);
      let hospitalCode = this.setEncrypt(this.HOSPITAL.code);
      let obj = {
        phone: phone,
        language: language,
        purpose: purpose,
        sys: sys,
        templateNo: templateNo,
        hospitalCode: hospitalCode,
      }
      debugger;
      this.$API.sendCode(obj).then(res => {
        if(res.code == 0) {
          this.$message.success("获取验证码成功！");
        }else {
          this.$message.error(res.msg);
          this.yzmNum = 120;
          this.yzmTxt = '获取验证码';
          clearInterval(this.yzmTimer);
        }
      });
    },
    // 发送请求
    sendPost() {
      const _this = this;
      console.log("sendPost")
      if(!this.username) {
        this.$message.warning("请输入手机号");
        return
      }
      if(!this.password) {
        this.$message.warning("请输入密码");
        return
      }
      let reg = /(?!^\d+$)(?!^[a-zA-Z]+$)[0-9a-zA-Z]{8,20}/;
      if(!reg.test(this.password)) {
        return this.$message.warning("请输入8-20位字母，数字结合的密码");
      }
      if(!this.picCode) {
        this.$message.warning("请输入图片验证码");
        return
      }
      if(this.picCode != this.selfPicYzm) {
        this.$message.warning("图片验证码错误");
        this.drawCanvas();
        return
      }
      let password = this.setEncrypt(this.password);
      let obj = {
        phone: this.username,
        pc: password,
        sys: "ohealth",
        encryptMode: 'RSA',
        hospitalCode: this.HOSPITAL.code,
      }
      debugger;
      this.$API.login(obj).then(res => {
        if(res.code == 0) {
          let ut = res.data.ut;
          let userId = res.data.userId;
          let regFrom = res.data.regFrom;
          let uacId = res.data.uacId;
          localStorage.setItem('ut', ut);
          localStorage.setItem('userId', userId);
          localStorage.setItem('uacId', uacId);
          localStorage.setItem('phone', this.username);
          window.parent.postMessage(
          {
            type: 'setUserInfo',
            userInfo: {
              userId,
              phone: this.username,
              ut
            },
          },
          '*'
        )
            // 返回登录以前的页面
          let path = '/personalCenter/personalInfomation'
          if (this.$route.query.redirect){
            path = this.$route.query.redirect; // 跳到之前的页面
          }
          this.$router.push(path);
          
        }else {
          // this.$message.error(res.msg);
          // this.drawCanvas();
        }
      },
      error => {
        this.drawCanvas();
      });
    },
    // 验证码登录请求
    sendSmsPost(){
      console.log("sendSmsPost")
      if(!this.username) {
        this.$message.warning("请输入手机号");
        return
      }
      if(!this.yzm) {
        this.$message.warning("请输入验证码");
        return
      }
      let obj = {
        phone: this.username,
        verifyCode: this.yzm,
        sys: "ohealth",
        hospitalCode: this.HOSPITAL.code,
      }
      this.$API.loginBySmsCode(obj).then(res => {
        if(res.code == 0) {
          let ut = res.data.ut;
          let userId = res.data.userId;
          // let regFrom = res.data.regFrom;
          let uacId = res.data.uacId;
          localStorage.setItem('ut', ut);
          localStorage.setItem('userId', userId);
          localStorage.setItem('uacId', uacId);
          localStorage.setItem('phone', this.username);
          window.parent.postMessage(
          {
            type: 'setUserInfo',
            userInfo: {
              userId,
              phone: this.username,
              ut
            },
          },
          '*'
        )
          // 返回登录以前的页面
          // let path = '/index'
          // console.log("login query:",this.$route.query);
          // if (this.$route.query.redirect){
          //   path = this.$route.query.redirect; // 跳到之前的页面
          // }
          // this.$router.push({path:path});
          this.$router.push('/personalCenter/personalInfomation');
        }else {
          this.drawCanvas();
          this.$message.error(res.msg);
        }
      },
      error => {
        this.drawCanvas();
        this.$message.error("验证码输入错误");
      });
    },
    // 绘制canvas
    drawCanvas() {
      this.selfPicYzm = 0;
      let selfNumList = [];
      let canvas = document.getElementById("yzm"); //获取到canvas对象
      let context = canvas.getContext("2d"); //获取到canvas绘图环境
      //设置画布大小
      canvas.width = 110;
      canvas.height = 50;
      context.fillStyle = 'white'        // 填充色
      // context.strokeRect(0,0,110,50); // 非填充矩形，只有边框
      context.fillRect(0,0,110,50);      // 填充矩形
      let aCode = [0,1,2,3,4,5,6,7,8,9];
      // 绘制随机数
      for(var i = 0; i < 4; i ++){
        var deg = Math.random() * 30 * Math.PI / 180;
        var x = 20 + i * 20;
        var y = 20 + Math.random() * 10;
        var index = Math.floor(Math.random()*aCode.length); //获取到一个随机的索引值
        var txt = aCode[index]; //获取到数组里面的随机的内容
        selfNumList.push(txt);
        context.font = "bold 20px 微软雅黑"; //设置文字样式
        context.fillStyle = this.getColor();
        context.translate(x,y);
        context.rotate(deg);
        context.fillText(txt,0,0);
        context.rotate(-deg);
        context.translate(-x,-y);
      }
      this.selfPicYzm = selfNumList.join('');
      //绘制干扰线
      for(var i = 0; i < 2; i ++ ){
        context.strokeStyle = this.getColor();
        context.beginPath();
        context.moveTo(Math.random()*120,Math.random()*40);
        context.lineTo(Math.random()*120,Math.random()*40);
        context.stroke();
      }
    },
    // 设置随机颜色
    getColor(){
      var r = Math.floor(Math.random() * 256);
      var g = Math.floor(Math.random() * 256);
      var b = Math.floor(Math.random() * 256);
      if(r == 255 && g == 255 && b == 255){
          r = 0;
          g = 0;
          b = 0;
      }
      return "rgb("+r+","+g+","+b+")";
    },
    // 跳转注册页
    goRegister() {
      this.$router.push('/personalCenter/register');
    },
    // 跳转重置密码页
    goResetPassword() {
      this.$router.push('/personalCenter/resetPassword');
    },
  }
};
</script>

<style lang="less" scoped>
.m-screen-pc {
    position: relative;
    width: 100%;
    height: 1000px;
    .temp-box {
      position: relative;
      width: 100%;
      // height: 600px;
      min-height: 945px;
    }
    .img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
    .login-form {
      position: absolute;
      top: 20%;
      right: 5%;
      padding: 50px 44px;
      width: 465px;
      height: 480px;
    }
    .bg-box {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #fff;
      opacity: 0.5;
      z-index: 1;
    }
    .real-box {
      position: relative;
      z-index: 2;
    }
    .tab{
      
    }
    .tabTitle{
      width: 39%;
      display:inline-block;
      text-align: center;
      font-size: 16px;
      color: #1D1E1F;
      line-height: 24px;
      padding-bottom: 8px;
      margin: 0 5% 24px;
    }
    .now {
      color: #0078D4;
      border-bottom: 2px solid #0078D4;
    }
    h2 {
      text-align: center;
      font-size: 30px;
      margin-bottom: 12px;
    }
    .usually-box {
      border: 1px solid #fff;
      padding: 6px 14px;
      position: relative;
      margin-bottom: 15px;
      &::after {
        display: block;
        content: "";
        overflow: hidden;
        visibility: hidden;
        clear: both;
      }
      label {
        float: left;
        width: 50px;
        margin-right: 10px;
        font-size: 16px;
        position: relative;
        top: 1px;
      }
      input {
        float: left;
        font: inherit;
        outline: 0;
        border: 0;
        height: 30px;
        width: 285px;
        background: none;
        // background-color: rgb(232, 240, 254);
        background-image: none !important;
      }
    }
    .yz-wrap {
      input {
        // background-color: transparent;
        width: 200px;
      }
      #yzm {
        position: absolute;
        top: 0;
        right: 0;
        width: 110px;
        height: 44px;
        background: #fff;
        border: 0;
      }
    }
    .yzt-wrap {
      input {
        width: 165px;
        // background-color: transparent;
      }
      .get-yzm {
        position: absolute;
        top: 0;
        right: 0;
        width: 110px;
        height: 44px;
        line-height: 44px;
        background: #0078d4;
        color: #fff;
        text-align: center;
        font-size: 16px;
        cursor: pointer;
      }
    }
    .login-btn {
      position: relative;
      margin-top: 32px;
      height: 54px;
      line-height: 54px;
      background: #0078d4;
      color: #fff;
      border-radius: 50px;
      text-align: center;
      img {
        position: absolute;
        top: 10px;
        left: 140px;
      }
      span {
        font-size: 16px;
      }
    }
    .txt {
      margin-top: 12px;
      display: flex;
      justify-content: space-between;
      a {
        color: #333;
      }
    }
}

.m-screen-mobile {
    position: relative;
    width: 100%;
    height: 8rem;
    .temp-box {
      position: relative;
      width: 100%;
      height: 9rem;
    }
    .img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
    .login-form {
      position: relative;
      margin: 0.3rem auto;
      padding: 0.6rem 0.4rem;
      width: 90%;
      height: 95%;
    }
    .bg-box {
      position: absolute;
      top: 10px;
      left: 0;
      width: 100%;
      height: 100%;
      background: #fff;
      opacity: 0.5;
      z-index: 1;
    }
    .real-box {
      position: relative;
      z-index: 2;
    }
    .tabTitle{
      width: 39%;
      display:inline-block;
      text-align: center;
      font-size: 16px;
      color: #1D1E1F;
      line-height: 24px;
      padding-bottom: 8px;
      margin: 0 5% 24px;
    }
    .now {
      color: #0078D4;
      border-bottom: 2px solid #0078D4;
    }
    h2 {
      text-align: center;
      font-size: 0.4rem;
      margin-bottom: 0.15rem;
    }
    .usually-box {
      border: 1px solid #fff;
      padding: 0.15rem 0.2rem;
      position: relative;
      margin-bottom: 0.2rem;
      &::after {
        display: block;
        content: "";
        overflow: hidden;
        visibility: hidden;
        clear: both;
      }
      label {
        float: left;
        width: 24%;
        margin-right: 10px;
        font-size: 16px;
        position: relative;
        top: 1px;
      }
      input {
        float: left;
        font: inherit;
        outline: 0;
        border: 0;
        width: 70%;
        height: 0.75rem;
        background: none;
        background-color: rgb(232, 240, 254);
        background-image: none !important;
        font-size: 16px;
      }
    }
    .yz-wrap {
      input {
        // background-color: transparent;
        width: 40%;
      }
      #yzm {
        position: absolute;
        top: 0;
        right: 0;
        width: 80px;
        height: 100%;
        background: #fff;
        border: 0;
      }
    }
    .yzt-wrap {
      .get-yzm {
        position: absolute;
        top: 0;
        right: 0;
        width: 110px;
        height: 100%;
        line-height: 2.5;
        background: #0078d4;
        color: #fff;
        text-align: center;
        font-size: 16px;
        cursor: pointer;
      }
    }
    .login-btn {
      position: relative;
      margin-top: 0.1rem;
      height: 1rem;
      line-height: 1rem;
      background: #0078d4;
      color: #fff;
      border-radius: 50px;
      text-align: center;
      img {
        position: absolute;
        top: 0.1rem;
        left: 1.3rem;
      }
      span {
        font-size: 16px;
      }
    }
    .txt {
      margin-top: 12px;
      display: flex;
      justify-content: space-between;
      a {
        color: #333;
      }
    }
}
</style>
